var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.995,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.27149 1.95923C7.65823 1.95337 11.0449 1.95923 14.4316 1.97681C15.1179 2.08886 15.5456 2.48144 15.7148 3.15454C15.7324 6.76389 15.7383 10.3733 15.7324 13.9827C11.9824 13.9768 8.2324 13.9827 4.48242 14.0002C4.00247 14.0114 3.75638 14.2575 3.74414 14.7385C3.75047 15.1197 3.93796 15.354 4.30664 15.4417C8.11522 15.4592 11.9238 15.4651 15.7324 15.4592C15.7324 15.9749 15.7324 16.4905 15.7324 17.0061C11.9121 17.012 8.09177 17.0061 4.27149 16.9885C3.43941 16.9042 2.82417 16.4999 2.42578 15.7756C2.33994 15.5846 2.28134 15.3854 2.25 15.178C2.22656 11.3811 2.22656 7.58423 2.25 3.78735C2.38992 3.01482 2.81765 2.4699 3.5332 2.15259C3.77961 2.07053 4.02571 2.00608 4.27149 1.95923Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.27b00098d0fd776a6036aacad558a625.svg";
export { ForwardRef as ReactComponent };